import { supabase } from '../supabaseClient';

/* Alerte de fin de phase : heures saisies après la fin des phases, détail d'une phase, phase
   laissée close, tickets Jira concernés. */

export function fetchHoursAfterEnd() {
  return supabase.rpc('phase_hours_after_end');
}

export function fetchLateTimesheets(brickIds, afterDate) {
  return supabase
    .from('timesheets')
    .select('id,user_id,dev_id,date,heures,source')
    .in('brique_id', brickIds)
    .gt('date', afterDate)
    .order('date', { ascending: false });
}

export function setLateHoursSeen(phaseId, heures) {
  return supabase.from('phases').update({ heures_hors_fin_vues: heures }).eq('id', phaseId);
}

export function fetchLateWorklogs(phaseId) {
  return supabase.functions.invoke('jira-sync', { body: { worklogsAfterPhaseEnd: { phaseId } } });
}
